<template>
  <div class="milestone-progress" :class="cssType">
    <div class="progress-labels">
      <div
        class="progress-label"
        v-for="(item, idx) in props.list"
        :key="item.rewardCode"
        :style="{ left: props.nodes[idx] + '%' }"
      >{{ $t('novShopping.milestone.spend', { n: item.targetSpent }) }}</div>
    </div>
    <div
      class="progress-bar"
      role="progressbar"
      :aria-label="$t('novShopping.milestone.header')"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-valuenow="Math.min(100, Math.max(0, Number(props.percent) || 0))"
    >
      <i
        class="progress-track"
        :style="{ clipPath: `inset(0 ${100 - Math.min(100, Math.max(0, Number(props.percent) || 0))}% 0 0)` }"
      ></i>
      <div
        class="progress-node"
        v-for="(item, idx) in props.list"
        :key="item.rewardCode"
        :style="{ left: props.nodes[idx] + '%' }"
        :class="{ reached: item.status !== 0, current: idx === lastReached }"
      >
        <i v-if="idx === lastReached" class="node-check"></i>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import { isMobile } from '@/utils'

const props = defineProps({
  list: {
    type: Array,
    default: () => [],
  },
  // 每个节点在进度条上的百分比位置，由父组件统一计算，竖版时间轴复用同一套算法
  nodes: {
    type: Array,
    default: () => [],
  },
  // 当前填充百分比
  percent: {
    type: Number,
    default: 0,
  },
})

const cssType = isMobile ? 'mobile' : 'pc'

// 最靠后的已达成分档打勾
const lastReached = computed(() => {
  let idx = -1
  props.list.forEach((item, i) => {
    if (item.status !== 0) idx = i
  })
  return idx
})
</script>

<style lang="less" scoped src="./pc_style.less"></style>
